var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('hr'),_c('b-img',{attrs:{"src":_vm.printer,"alt":"today"}}),_c('a',{staticClass:"text-14 mb-0 text-primary semi-bold",attrs:{"href":"https://www.mypay.sk/vypisy/","target":"new"}},[_vm._v(" "+_vm._s(_vm.$t("print-receipt"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }